import React from 'react';
import css from './SectionHero.module.css';
import RenderLandingPageSectionHero from './RenderLandingPageSectionHero';
import { DEFAULT_CONSTANTS } from '../../../util/enums';
function SectionHero(props) {
  const { bannerTitle, bannerImage = DEFAULT_CONSTANTS.BANNER_IMAGE_CATEGORIES } = props;

  return (
    <div
      className={css.sectionHeroContainer}
      style={
        bannerImage
          ? {
              backgroundImage: `url(${bannerImage})`,
            }
          : {}
      }
    >
      <div className={css.sectionHeroContent}>
        <h1>{bannerTitle}</h1>
        <RenderLandingPageSectionHero bannerImage={bannerImage} />
      </div>
    </div>
  );
}

export default SectionHero;
